import React from "react";
import "./FeatureCard.scss";
const FeatureCard = ({ image, text, title }) => {
  return (
    <div className="feature-card mx-auto mt-3 mb-5 col-md-3">
      <div className="card ">
        <img src={image} className="card-img-top feature-img p-2" alt="..." />
        <div className="card-body featue-body p-0">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{text}</p>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
